import { __extends } from "tslib";
// DS: CR18S
import React from 'react';
import get from 'lodash/get';
import { withTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { NotificationType } from '../../Notifications/redux/types';
import Notification from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import AddToFaveIcon from '../../Icons/24x24/AddedToFav';
import RemoveFaveIcon from '../../Icons/24x24/RemovedFromFav';
import CheckIcon from '../../Icons/Check';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import { BiEventType } from '../../biLogger/constants';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import BiLink from '../../biLogger/Components/BiLink';
import { ResourceType } from '../../types/resource';
import { GallectionResourceType } from '../../types/gallection';
var keys = {
    addOne: 'collectionPanel.notification.addedToCollection.v2',
    addMany: 'collectionPanel.notification.addedToCollection.multi.v2',
    removeOne: 'collectionPanel.notification.removedFromCollection.v2',
    removeSome: 'collectionPanel.notification.removedFromCollection.multi.v2',
    removeAll: 'collectionPanel.notification.removedFromAllCollections.v2',
    misc: 'collectionPanel.notification.miscChanges.v2',
    none: '',
};
var undoMap = {
    removeOne: 'addOne',
    removeSome: 'addMany',
    removeAll: 'addMany',
    addOne: 'removeOne',
    addMany: 'removeSome',
    misc: 'misc',
    none: 'none',
};
export var SCROLL_TO_FOLDER_HASH_SIGNAL = 'scrollIntoView';
var CollectNotification = /** @class */ (function (_super) {
    __extends(CollectNotification, _super);
    function CollectNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onUndo = function () {
            var _a = _this.props, deviationId = _a.collectedDeviation.deviationId, onUndo = _a.onUndo, removeNotification = _a.removeNotification, id = _a.id;
            onUndo(deviationId);
            removeNotification(id);
        };
        return _this;
    }
    CollectNotification.prototype.render = function () {
        var _a = this.props, id = _a.id, t = _a.t, collectedDeviation = _a.collectedDeviation, queueName = _a.queueName, addNotification = _a.addNotification, isAddToFave2 = _a.isAddToFave2;
        return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: {
                iconComponent: this.getIcon(),
                backgroundDeviation: collectedDeviation,
                actions: [
                    !this.isUndo() &&
                        !isAddToFave2 && {
                        type: 'negative',
                        label: t('collectionPanel.notification.undo'),
                        onClick: this.onUndo,
                        biData: {
                            evid: BiEventType.POPUP_CLICK_UNDO_FAVE,
                            itemid: collectedDeviation.deviationId,
                            typeid: getDeviationResourceType(collectedDeviation),
                            creatorid: get(collectedDeviation, 'author.useridUuid'),
                        },
                    },
                ],
            }, onClose: queueName === getDeviationNotificationQueue(collectedDeviation) &&
                !this.isUndo()
                ? function () { return addNotification(queueName, 'commentReminder', {}); }
                : undefined }, this.renderTitle()));
    };
    CollectNotification.prototype.getIcon = function () {
        var changeType = this.props.changeType;
        switch (changeType) {
            case 'removeAll':
            case 'removeOne':
            case 'removeSome':
                return RemoveFaveIcon;
            case 'addMany':
            case 'addOne':
                return AddToFaveIcon;
            default:
                return CheckIcon;
        }
    };
    CollectNotification.prototype.renderTitle = function () {
        var _a = this.props, changeType = _a.changeType, t = _a.t, exampleCollection = _a.exampleCollection, currentUser = _a.currentUser;
        var effectiveChange = this.isUndo() ? undoMap[changeType] : changeType;
        var key = keys[effectiveChange];
        if (!key || !currentUser) {
            return null;
        }
        switch (effectiveChange) {
            case 'addMany':
                return (
                // prettier-ignore
                React.createElement(Trans, { i18nKey: key },
                    "Added to ",
                    React.createElement(BiLink, { biData: {
                            evid: BiEventType.ITEM_CLICK,
                            itemid: currentUser.userId,
                            typeid: ResourceType.USER
                        }, href: Url.userGalleryLink({ username: currentUser.username, gallectionType: 'collection' }) }, "Collections")));
            case 'addOne':
            case 'removeOne':
                var collection = exampleCollection
                    ? exampleCollection.name
                    : t('collectionPanel.aCollection');
                var url = exampleCollection
                    ? Url.userGalleryLink({
                        username: currentUser.username,
                        gallectionType: 'collection',
                        folderId: exampleCollection.folderId,
                        folderName: exampleCollection.name,
                    })
                    : Url.userGalleryLink({
                        username: currentUser.username,
                        gallectionType: 'collection',
                    });
                var biData = exampleCollection
                    ? {
                        evid: BiEventType.ITEM_CLICK,
                        itemid: exampleCollection.folderId,
                        typeid: GallectionResourceType.COLLECTION,
                    }
                    : {
                        evid: BiEventType.ITEM_CLICK,
                        itemid: currentUser.userId,
                        typeid: ResourceType.USER,
                    };
                return (
                // prettier-ignore
                React.createElement(Trans, { i18nKey: key },
                    "Changed in ",
                    React.createElement(BiLink, { biData: biData, href: url + "#" + SCROLL_TO_FOLDER_HASH_SIGNAL }, { collection: collection })));
            default:
                return t(key);
        }
    };
    CollectNotification.prototype.isUndo = function () {
        return this.props.type === NotificationType.CollectUndo;
    };
    return CollectNotification;
}(React.Component));
export { CollectNotification };
export default withTranslation()(CollectNotification);
//# sourceMappingURL=CollectNotification.js.map